<mat-toolbar class="mat-elevation-z3 d-flex justify-content-between z-3 position-relative">
  <button mat-icon-button (click)="toggleSidebar()">
    <mat-icon>menu</mat-icon>
  </button>
  <div>
    @if (environment.agrinio) {
    <!-- @if ((requests$ | async); as requests) { -->
    <button mat-icon-button [matMenuTriggerFor]="notificationMenu" class="me-2">
      <mat-icon>notifications</mat-icon>
      <!-- <mat-badge [matBadge]="requests.length" matBadgeColor="warn" matBadgeOverlap="false"></mat-badge> -->
    </button>
    <mat-menu #notificationMenu="matMenu">
    </mat-menu>
    }
    <!-- } -->
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>account_circle</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button mat-menu-item>
        <mat-icon>settings</mat-icon>
        <span>Account</span>
      </button>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>